/* Start Error Label */
let LABEL_LOGIN_ERROR = "LABEL_LOGIN_ERROR";
let BUTTON_YES = "BUTTON_YES";
let BUTTON_NO = "BUTTON_NO";
let LABEL_EMPTY_TABLE = "LABEL_EMPTY_TABLE";
let LABEL_DIALOG_LOGOUT = "LABEL_DIALOG_LOGOUT";
let LABEL_DIALOG_DEACTIVATION_SUCCESS = "LABEL_DIALOG_DEACTIVATION_SUCCESS";
let LABEL_DIALOG_DEACTIVATION_FAILED = "LABEL_DIALOG_DEACTIVATION_FAILED";
let LABEL_DIALOG_DEACTIVATION_RESUME = "LABEL_DIALOG_DEACTIVATION_RESUME";
let ERROR_VALIDATION_YEAR_FUTURE_INVALID = "ERROR_VALIDATION_YEAR_FUTURE_INVALID";
let VALIDATION_AMOUNT_INVALID = "VALIDATION_AMOUNT_INVALID";
let WARNING_AFM_TAXIS_MAX_SEARCH = "WARNING_AFM_TAXIS_MAX_SEARCH";
let WARNING_SYMV_YPOXREOI = "WARNING_SYMV_YPOXREOI";
let TABLE_SYMV_YPOXREOI = "TABLE_SYMV_YPOXREOI";
let TABLE_SYMV_YPOXREOI_GENERAL_BUTTON_NAV = "TABLE_SYMV_YPOXREOI_GENERAL_BUTTON_NAV";
let TABLE_SYMV_YPOXREOI_GENERAL_BUTTON = "TABLE_SYMV_YPOXREOI_GENERAL_BUTTON";
/* End Error Label */

/* Start Field Label */
let FIELD_AFM = "FIELD_AFM";
let FIELD_LAST_NAME = "FIELD_LAST_NAME";
let FIELD_FIRST_NAME = "FIELD_FIRST_NAME";
let FIELD_FATHERS_NAME = "FIELD_FATHERS_NAME";
let FIELD_EMAIL = "FIELD_EMAIL";
let FIELD_ODOS = "FIELD_ODOS";
let FIELD_KINHTO = "FIELD_KINHTO";
let FIELD_TK = "FIELD_TK";
let FIELD_PHONE = "FIELD_PHONE";
let FIELD_ARIUMOS = "FIELD_ARIUMOS";
let FIELD_DESCRIPTION = "FIELD_DESCRIPTION";
let FIELD_IS_ACTIVE = "FIELD_IS_ACTIVE";
let FIELD_HMNIA_ORISTIKO = "FIELD_HMNIA_ORISTIKO";
let FIELD_TIMIMA = "FIELD_TIMIMA";
let FIELD_AFM_YPOXREON = "FIELD_AFM_YPOXREON";
let FIELD_FILE_NAME = "FIELD_FILE_NAME";
let FIELD_SYMVOLAIO_EMPR_DIKAIOMA = "FIELD_SYMVOLAIO_EMPR_DIKAIOMA";
let FIELD_HMNIA_SYNTAKSIS = "FIELD_HMNIA_SYNTAKSIS";
let FIELD_AR_SYMVOLAIOU = "FIELD_AR_SYMVOLAIOU";
let FIELD_SYGGENIKI_SXESI = "FIELD_SYGGENIKI_SXESI";
/* End Field Label */

/* Start Button  Label*/
let BUTTON_CONTRACT_BACK = "BUTTON_CONTRACT_BACK";
let BUTTON_CONTRACT_CREATE = "BUTTON_CONTRACT_CREATE";
let LABEL_DPK_DETAILS_TAXIS_BUTTON = "LABEL_DPK_DETAILS_TAXIS_BUTTON";
let LABEL_BACK = "LABEL_BACK";
/* End Button  Label*/

let LABEL_LOGIN_TITLE_SYMVOLAIOGRAFOS_APP = "LABEL_LOGIN_TITLE_SYMVOLAIOGRAFOS_APP";

export const captions_el = [];
/* Start Error Caption */
captions_el[LABEL_LOGIN_ERROR] = "<b>Η σύνδεση στην εφαρμογή αυτή επιτρέπεται μόνο σε πρόσωπα με την ιδιότητα του συμβολαιογράφου!</b>";
captions_el[BUTTON_YES] = "Ναι";
captions_el[BUTTON_NO] = "Όχι";
captions_el[LABEL_EMPTY_TABLE] = "Δεν βρέθηκαν εγγραφές.";
captions_el[LABEL_DIALOG_LOGOUT] = "Θέλετε να αποσυνδεθείτε από το σύστημα και να χαθούν οι μη αποθηκευμένες αλλαγές;";
captions_el[LABEL_DIALOG_DEACTIVATION_SUCCESS] = "Η Ενημέρωση Ολοκληρώθηκε.";
captions_el[LABEL_DIALOG_DEACTIVATION_FAILED] = "Η Ενημέρωση του Συμβολαίου Απέτυχε.";
captions_el[LABEL_DIALOG_DEACTIVATION_RESUME] = "Το Συμβόλαιο είναι ήδη Απενεργοποιημένο.";
captions_el[ERROR_VALIDATION_YEAR_FUTURE_INVALID] = " Η Ημ/νία πρέπει να είναι μικρότερη ή ίση με την Σημερινή.";
captions_el[VALIDATION_AMOUNT_INVALID] = "Πρέπει να είναι αριθμός. <br/>Ο διαχωρισμός χιλιάδων με τελεία (.) και υποδιαστολή με κόμμα (,) π.χ 2.500,23";
captions_el[WARNING_SYMV_YPOXREOI] = "Πρέπει να έχεις προσθέσει τουλάχιστον ένα πρόσωπο συμβολαίου";
captions_el[TABLE_SYMV_YPOXREOI] = "Πρόσωπα Συμβολαίου";
captions_el[TABLE_SYMV_YPOXREOI_GENERAL_BUTTON_NAV] = "Προσθήκη Προσώπου";
captions_el[TABLE_SYMV_YPOXREOI_GENERAL_BUTTON] = "Διαγραφή Προσώπου";
captions_el[WARNING_AFM_TAXIS_MAX_SEARCH] = ' Έχετε φτάσει στο μέγιστο επιτρεπτό αριθμό αναζητήσεων ΑΦΜ. Παρακαλώ προσπαθήστε αργότερα.'

/*  End Error Caption */

captions_el[FIELD_AFM] = "Α.Φ.Μ.";
captions_el[FIELD_LAST_NAME] = "Επώνυμο";
captions_el[FIELD_FIRST_NAME] = "Όνομα";
captions_el[FIELD_FATHERS_NAME] = "Όνομα Πατρός";
captions_el[FIELD_EMAIL] = "Ηλεκτρονικό Ταχυδρομείο (e-mail)";
captions_el[FIELD_PHONE] = "Σταθερό Τηλέφωνο";
captions_el[FIELD_KINHTO] = "Κινητό Τηλέφωνο";
captions_el[FIELD_ODOS] = "Διεύθυνση Κατοικίας (Πόλη,Οδός)";
captions_el[FIELD_ARIUMOS] = "Αριθμός";
captions_el[FIELD_TK] = "Τ.Κ.";
captions_el[FIELD_DESCRIPTION] = "Περιγραφή";
captions_el[FIELD_IS_ACTIVE] = "Ενεργή Εγγραφή";
captions_el[FIELD_HMNIA_ORISTIKO] = "Ημ/νία Οριστικοποίησης";
captions_el[FIELD_TIMIMA] = "Τίμημα (€)";
captions_el[FIELD_AFM_YPOXREON] = "ΑΦΜ Προσώπων Συμβολαίου";
captions_el[FIELD_FILE_NAME] = "Όνομα Αρχείου (pdf)";
captions_el[FIELD_SYMVOLAIO_EMPR_DIKAIOMA] = "Αιτία Κτήσης";
captions_el[FIELD_HMNIA_SYNTAKSIS] = "Ημ/νία Σύνταξης Συμβολαίου";
captions_el[FIELD_AR_SYMVOLAIOU] = "Αρ.Συμβολαίου";
captions_el[FIELD_SYGGENIKI_SXESI] = "Συγγενική Σχέση";

captions_el[BUTTON_CONTRACT_BACK] = "Επιστροφή";
captions_el[BUTTON_CONTRACT_CREATE] = "Δημιουργία";
captions_el[LABEL_DPK_DETAILS_TAXIS_BUTTON] = "Ενημέρωση από TAXIS";
captions_el[LABEL_BACK] = "Επιστροφή";
captions_el[LABEL_LOGIN_TITLE_SYMVOLAIOGRAFOS_APP] = "<h3 style=\"font-weight: normal\" >Υποβολή Συμβολαίων από Συμβολαιογράφους</h3>";